$shm_hitalama_projects_map $mol_view
	projects $shm_hitalama_projects
	sub /
		<= Book $mol_book2
			placeholders /
			pages <= pages /$mol_view
